module.exports = __webpack_public_path__ + "assets/player-pause.png";